import React from "react";
import styles from "../styles/TestimonialCard.module.css";
import starIcon from "@assets/home2/featured/star_icon.svg"

const TestimonialCard = ({ image, name, role, rating, testimonial }) => {
  return (
    <div className={styles.testimonialCard}>
      <img
        src={image}
        alt={`${name}'s profile`}
        className={styles.profileImage}
      />
      <h3 className={styles.name}>{name}</h3>
      <p className={styles.role}>{role}</p>
      <div className={styles.rating}>
        {[...Array(5)].map((_, index) => (
          <img
            key={index}
            src={starIcon}					
            alt=""
            className={styles.starIcon}
          />
        ))}
      </div>
      <p className={styles.testimonialText}>{testimonial}</p>
    </div>
  );
};

export default TestimonialCard;
